import { opmStorage } from "./opmStorage";
import { removeCookie } from "./cookies";

/** Fired on window when the guest's OPM token is no longer valid (expired or refused). */
export const SESSION_EXPIRED_EVENT = "opm:session-expired";

/**
 * True when a JWT's `exp` has passed. The token is only decoded, not verified: this is a
 * shortcut so an expired token is never sent; the API still decides on every request.
 */
export const isJwtExpired = (token) => {
  try {
    const raw = String(token).replace(/^bearer\s+/i, "");
    const payload = JSON.parse(
      atob(raw.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))
    );
    return typeof payload.exp === "number" && payload.exp * 1000 <= Date.now();
  } catch {
    return false;
  }
};

/** Remove everything OPM saved in this browser: all `opm:*` storage and the opm_* cookies. */
export const clearOpmBrowserData = () => {
  opmStorage.disableWrites();
  opmStorage.clearAll();
  ["opm_token", "opm_restaurant_id", "opm_element_id"].forEach(removeCookie);
};

/** Why the guest's table connection ended: picks the popup's text. */
export const SessionEndReason = {
  EXPIRED: "expired",
  TABLE_CLOSED: "table_closed",
  // The table closed while the guest was on the payment page; nothing was charged.
  TABLE_CLOSED_UNCHARGED: "table_closed_uncharged",
};

export const notifySessionExpired = (reason = SessionEndReason.EXPIRED) => {
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT, { detail: { reason } }));
};
